import { Alert, AlertDescription, AlertTitle } from '../../../components/ui/alert'
import { ACTION_LABEL, MOD_RESOURCES } from './constants'
import { WizardChrome } from './WizardChrome'
import type { IngestWizardApi } from './useIngestWizard'

interface StepModifyPlaceholderProps {
  wizard: IngestWizardApi
}

/** Temporary stand-in for update-target / remove / doc-map stages until those paths are wired. */
export function StepModifyPlaceholder({ wizard }: StepModifyPlaceholderProps) {
  const { state, backToPick } = wizard
  const res = MOD_RESOURCES.find((r) => r.id === state.modResource)
  const action = state.modAction ? ACTION_LABEL[state.modAction] : ''
  const stageLabel =
    state.modStage === 'remove'
      ? 'Delete'
      : state.modStage === 'docmap'
        ? 'Document revisions'
        : 'Update target'

  return (
    <WizardChrome
      eyebrow={`Step 03 — ${stageLabel}`}
      title={`${action} ${res?.label ?? 'resource'}`}
      description="This modify path needs a target picker that isn’t wired into the live ontology inventory yet."
      onBack={backToPick}
    >
      <Alert>
        <AlertTitle>Not available in this build</AlertTitle>
        <AlertDescription>
          Use <strong>Add</strong> for new PLC / robotics / MTConnect / Experion / SRS / Safety
          Manager / documentation sources, or <strong>Update</strong> on SCADA and IP maps (those
          reuse the prepare step). Target-specific update, delete, and document-revision mapping
          will land in a follow-up.
        </AlertDescription>
      </Alert>
    </WizardChrome>
  )
}
